import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { DetailTicketLine } from '../Tickets';
import { Link, useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.containerGrid,
  },
  title: {
    margin: '.5rem 1rem',
    '& p': { ...theme.subTitle, fontSize: '20px' },
  },
  listItem: {
    background: 'white',
    height: '55px',
    margin: '5px 0',
    padding: '1rem',
  },
}));
const AllTickets = ({ list }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();

  const redirect = (e, id) => {
    e.preventDefault();
    const pathname = `/ticket/:${id}`;
    history.push(pathname);
  };

  return (
    <Grid container direction="column" className={classes.root}>
      <Grid item className={classes.title}>
        <Typography>{t('my_orders')}</Typography>
      </Grid>
      <Grid item>
        <Grid container>
          {list
            .map((ticket, id) => {
              return (
                <Grid
                  item
                  xs={12}
                  key={`ticket-order-${ticket.ticketAlias}-${id}`}
                  className={classes.listItem}
                >
                  <Link
                    to={{}}
                    onClick={(e) => redirect(e, ticket.ticketAlias)}
                  >
                    <DetailTicketLine date={ticket.date} total={ticket.total} />
                  </Link>
                </Grid>
              );
            })
            .reverse()}
        </Grid>
      </Grid>
    </Grid>
  );
};

AllTickets.propTypes = {};

export default AllTickets;
